import axios from 'axios';

export default {
    install(Vue) {

        Vue.$api2 =
        {
            axios: axios,
            apiUrl: process.env.VUE_APP_BASE_URL2,
            config: null,
            _updateHeaders: function () {
                Vue.$api2.config = {
                    headers: {
                        "content-type": "application/json",
                        "Authorization": "Bearer " + sessionStorage.getItem("session-id")
                    },
                    baseURL: Vue.$api2.apiUrl,
                    withCredentials: true,
                };
                Vue.$api2.configBlob = {
                    headers: {
                        "content-type": "application/json",
                        "Authorization": "Bearer " + sessionStorage.getItem("session-id")
                    },
                    baseURL: Vue.$api2.apiUrl,
                    withCredentials: true,
                    responseType: 'blob',
                };
            }.bind(this),

        }
        Vue.$api2._updateHeaders();

        Vue.prototype.$api2 = function () {
            return {

                updateHeaders: function () {
                    Vue.$api2._updateHeaders();
                },
                getBaseUrl: function () {
                    return Vue.$api2.apiUrl;
                },
                get: function (url) {
                    return new Promise((resolve, reject) => {
                        Vue.$api2.axios.get(url)
                            .then((response) => {
                                if (response.status === 200) {
                                    resolve(response);
                                } else {
                                    reject('Bad request ' + response.code.toString());
                                }
                            })
                            .catch((err) => {
                                if (err.message === 'Network Error') {
                                    this.$root.$emit('offline');
                                    reject('Network Error');
                                }
                                else {
                                    reject('Server error');
                                }
                            });
                    });
                }.bind(this),

                // GenerateAndSendRapport
                GenerateAndSendRapport: function (data) {
                    return new Promise((resolve, reject) => {
                        let config = Vue.$api2.config;
                        Vue.$api2.axios.post('Rapport/GenerateAndSendRapport', data, config)
                            .then((response) => {
                                if (response.status === 200) {
                                    resolve(response);
                                } else {
                                    reject('Bad request ' + response.code.toString());
                                }
                            })
                            .catch((err) => {
                                if (err.message === 'Network Error') {
                                    this.$root.$emit('offline');
                                    reject('Network Error');
                                }
                                else {
                                    reject('Server error');
                                }
                            });
                    });
                }.bind(this),

                // Kaart_pFoto
                GetThumbnail: function(id) {
                    return new Promise((resolve, reject) => {
                        let config = Vue.$api2.configBlob;
                        Vue.$api2.axios.get(`Bewijs/Image/Thumbnail/${id}`, config)
                            .then((response) => {
                            if (response.status === 200) {
                                resolve(response);
                            } else {
                                reject('Bad request ' + response.code.toString());
                            }
                        })
                        .catch((err) => {
                            if (err.message === 'Network Error') {
                                this.$root.$emit('offline');
                                reject('Network Error');
                            }
                            else {
                                reject('Server error');
                            }
                        });
                    });
                }.bind(this),


            }
        }
    }
};
